import Modals from './Modals';

export default Modals;



// WEBPACK FOOTER //
// ./src/containers/Modals/index.js